import { observer } from 'mobx-react-lite'
import { SpinnerLoader, Switch, Typography } from 'shared/ui'
import { BusinessAddressForm } from 'pages/settings/ui/BusinessAddressForm'
import { type BillingAddressStore } from './store/billingAddressStore'
import styles from './styles.module.scss'

export type IBillingAddressContentProps = {
  store: BillingAddressStore
}

export const BillingAddressContent = observer(({ store }: IBillingAddressContentProps) => {
  const { addressFormStore } = store

  return (
    <div className={styles.container}>
      {store.loading && (
        <div className={styles.loaderContainer}>
          <SpinnerLoader ariaLabel='BillingAddressContent' />
        </div>
      )}
      {store.isBusinessInformationFilled && (
        <div className={styles.switchRow}>
          <Typography ariaLabel='use_compliance_address' variant='body-md-regular'>
            Use address from compliance
          </Typography>
          <Switch
            ariaLabel='use_compliance_address_switch'
            size='middle'
            value={store.useComplianceAddress}
            onChange={store.setUseComplianceAddress}
          />
        </div>
      )}

      <BusinessAddressForm
        addressData={addressFormStore.addressData}
        countries={addressFormStore.countries}
        activeCountryId={addressFormStore.activeCountryId}
        activeCountryInfo={addressFormStore.activeCountryInfo}
        states={addressFormStore.states}
        zipCode={addressFormStore.zipCode}
        zipLocalErrorMessage={addressFormStore.zipLocalErrorMessage}
        setActiveCountry={addressFormStore.setActiveCountry}
        setStreet1={addressFormStore.setStreet1}
        setStreet2={addressFormStore.setStreet2}
        setCity={addressFormStore.setCity}
        setState={addressFormStore.setState}
        setZip={addressFormStore.setZip}
        checkZipLength={addressFormStore.checkZipLength}
        countrySelectClassName={styles.countrySelect}
        disabled={store.useComplianceAddress}
      />
    </div>
  )
})
